import * as React from "react"
// import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils/helpers"



const buttonVariants = cva(
    "inline-flex items-center justify-center rounded-lg text-lg font-sans font-semibold ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
    {
        variants: {
            variant: {
                default: "bg-white text-zinc-900 hover:bg-white/80 shadow border border-white",
                outline:
                    "border border-white bg-white text-white bg-opacity-20 hover:bg-white/10",
                destructive:
                    "bg-red-500 text-white text-gray-50 hover:bg-red-500/90",
                secondary:
                    "border-blue-600 bg-neutral-900 text-white border border-transparent hover:border hover:border-[#155EEF] hover:shadow-lg hover:shadow-[#155EEF]",
                ghost: "hover:bg-gray-100 hover:text-gray-900",
                link: "text-gray-900 underline-offset-4 hover:underline",
            },
            size: {
                default: "h-10 px-4 py-2",
                sm: "h-9 px-3",
                lg: "h-12 px-5",
                '2xl': "h-[60px] px-7 py-4",
                icon: "h-10 w-10",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
)
const buttonVariantsPartner = cva(
    "inline-flex items-center justify-center rounded-lg text-sm md:text-lg font-sans font-semibold ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
    {
        variants: {
            variant: {
                default: "bg-white text-zinc-900 hover:bg-white/80 shadow border border-white",
                outline:
                    "border border-white bg-white text-white bg-opacity-20 hover:bg-white/10",
                destructive:
                    "bg-red-500 text-white text-gray-50 hover:bg-red-500/90",
                secondary:
                    "border-blue-600 bg-neutral-900 text-white border border-transparent hover:border hover:border-[#155EEF] hover:shadow-lg hover:shadow-[#155EEF]",
                ghost: "hover:bg-gray-100 hover:text-gray-900",
                link: "text-gray-900 underline-offset-4 hover:underline",
            },
            size: {
                default: "h-10 px-4 py-2",
                sm: "h-9 px-3",
                lg: "h-12 px-5",
                '2xl': "h-[60px] px-7 py-4",
                icon: "h-10 w-10",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
)


const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    // const Comp = asChild ? Slot : "button"
    const Comp = "button"
    return (
        (<Comp
            className={cn(buttonVariants({ variant, size, className }))}
            ref={ref}
            {...props} />)
    )
})
Button.displayName = "Button"

export { Button, buttonVariants, buttonVariantsPartner }
